// extracted by mini-css-extract-plugin
export default {"container":"FrequencyCellRenderer_container__F3xp-","message":"FrequencyCellRenderer_message__PdRW-","overdueMessage":"FrequencyCellRenderer_overdueMessage__+YWLi"};